<modal>
  <span header>{{'Chỉnh sửa tên đơn hàng' | lang}}</span>

  <p>{{'Tên đơn' | lang}}</p>
  <small *ngIf="error">{{'Trùng mã đơn, xin vui lòng chọn tên khác' | lang}}</small>
  <input type="text" [(ngModel)]="tag.Tag" [disabled]="loading"/>

  <div class="flex">
    <button class="text-white bg-success" (click)="save()" [disabled]="loading || empty"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()" [disabled]="loading"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
